import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatLegacySlideToggleModule as MatSlideToggleModule } from '@angular/material/legacy-slide-toggle';
import { MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { TeamActionMockEstablishmentTeamsTabComponent } from './app/establishment-teams-tab/team-action-mock-establishment-teams-tab.component';
import { TeamActionMockTeamPageComponent } from './app/team-page/team-action-mock-team-page.component';
import { TeamActionMockTeamsPageComponent } from './app/teams-page/team-action-mock-teams-page.component';
import { TeamActionMockPurchaseActorTeamComponent } from './screens/purchase-actor-team/team-action-mock-purchase-actor-team.component';
import { TeamActionMockTeamFormModalComponent } from './screens/team-form-modal/team-action-mock-team-form-modal.component';
import { TeamActionMockTeamDetailsScreenComponent } from './screens/team-details/team-action-mock-team-details-screen.component';
import { TeamActionMockTeamMemberAddModalComponent } from './screens/team-member-add-modal/team-action-mock-team-member-add-modal.component';
import { TeamActionMockTeamMemberRemovalModalComponent } from './screens/team-member-removal-modal/team-action-mock-team-member-removal-modal.component';
import { TeamActionMockTeamTableComponent } from './screens/team-table/team-action-mock-team-table.component';
import { TeamActionMockUserTeamsCardComponent } from './screens/user-teams-card/team-action-mock-user-teams-card.component';
import { TeamActionMockNewBadgeComponent } from './team-action-mock-new-badge.component';
import { TeamActionMockNewToggleComponent } from './team-action-mock-new-toggle.component';
import { TeamActionMockTeamBadgeComponent } from './team-action-mock-team-badge.component';

const COMPONENTS = [
  TeamActionMockNewBadgeComponent,
  TeamActionMockNewToggleComponent,
  TeamActionMockTeamBadgeComponent,
  TeamActionMockTeamTableComponent,
  TeamActionMockTeamDetailsScreenComponent,
  TeamActionMockTeamMemberAddModalComponent,
  TeamActionMockTeamMemberRemovalModalComponent,
  TeamActionMockTeamFormModalComponent,
  TeamActionMockUserTeamsCardComponent,
  TeamActionMockPurchaseActorTeamComponent,
  TeamActionMockTeamsPageComponent,
  TeamActionMockTeamPageComponent,
  TeamActionMockEstablishmentTeamsTabComponent,
];

// Maquette d'estimation « action d'équipe » : composants partagés entre les pages de la maquette et les vrais écrans
// (menu Équipes, fiche établissement, fiche utilisateur, acteurs achat). Branche d'estimation, jamais fusionnée.
@NgModule({
  declarations: COMPONENTS,
  exports: COMPONENTS,
  imports: [
    CommonModule,
    FormsModule,
    MatIconModule,
    MatButtonModule,
    MatCheckboxModule,
    MatDialogModule,
    MatDividerModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatSlideToggleModule,
    MatTableModule,
    MatTooltipModule,
  ],
})
export class TeamActionMockSharedModule {}
